module.exports = __webpack_public_path__ + "img/icon-num7.5099945b.png";